import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const getCostCenters = catchAsync(async () => {
    const { data } = await axiosInstance.get(
      `/api/resource/Cost Center?fields=["name","parent_cost_center","is_group","cost_center_number","cost_center_name"]`
    );
    return data;
  });
export const getCostCenterParties = catchAsync(async () => {
    const { data } = await axiosInstance.get(
      `/api/resource/Cost Center?fields=["name","cost_center_name"]`
    );
    return data;
  });
export const getCostCenterDetails = catchAsync(async (id) => {
    const { data } = await axiosInstance.get(
      `/api/resource/Cost Center/${id}`
    );
    return data;
  });
export const addCostCenter = catchAsync(async (body) => {
    const { data } = await axiosInstance.post(
      `/api/resource/Cost Center`,
      body
    );
    return data;
  });
  export const updateCostCenter = catchAsync(async (id, body) => {
    const { data } = await axiosInstance.put(
      `/api/resource/Cost Center/${id}`,
      body
    );
    return data;
  });
  
export const deleteCostCenter = catchAsync(async (id) => {
    const { data } = await axiosInstance.delete(
      `/api/resource/Cost Center/${id}`
    );
    return data;
  });